function makeUniqueProductId(productId, shopId, selectedSku) {
  const variantGroupCodeOrSku = (productId.split(':')[1] || '').split('/')[0] || productId;

  if (variantGroupCodeOrSku === selectedSku || selectedSku === undefined) {
    return "".concat(variantGroupCodeOrSku, "/").concat(shopId);
  }

  return "".concat(selectedSku, "/").concat(shopId);
}

export default makeUniqueProductId;